import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=73dcaefe&scoped=true"
import script from "./Matching.vue?vue&type=script&lang=ts"
export * from "./Matching.vue?vue&type=script&lang=ts"
import style0 from "./Matching.vue?vue&type=style&index=0&id=73dcaefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dcaefe",
  null
  
)

export default component.exports